import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Cloud.svg?component
var Cloud_exports = /* @__PURE__ */ __exportAll({
	default: () => Cloud_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M18.375 19.5a4.875 4.875 0 1 0-2.764-8.885A7.5 7.5 0 1 0 8.25 19.5z" }, null, -1)])]);
}
var Cloud_default = { render: render$1 };
//#endregion
export { Cloud_exports, Cloud_default as default, render$1 as render };

//# sourceMappingURL=Cloud.svg_component.js.map